// src/components/common/SettingCounterSwitch.js
import React, { useRef } from "react";

export default function SettingCounterSwitch({
  label,
  description,
  value,
  min,
  max,
  step,
  onUpdate,
  onReset,
}) {
  const intervalRef = useRef(null);

  const handleUpdate = (change) => {
    onUpdate((prevValue) => {
      const newValue = Math.max(min, Math.min(max, prevValue + change));
      return newValue;
    });
  };

  const handlePressEnd = (e) => {
    if (e && e.cancelable) e.preventDefault();
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const handlePressStart = (e, change) => {
    if (e.cancelable && e.type === "touchstart") {
      e.preventDefault();
    }
    handlePressEnd();
    handleUpdate(change);
    intervalRef.current = setInterval(() => {
      handleUpdate(change);
    }, 150);
  };

  return (
    <div className="flex items-center justify-between w-full p-3 bg-[#e1d4be] rounded-lg border border-[#c8bda9] shadow-inner">
      <div className="flex items-center">
        <div className="flex items-center">
          <div>
            <span className="font-semibold text-sm text-[#5a4a3a]">
              {label}
            </span>
            <p className="text-xs text-gray-600">{description}</p>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        {value !== 60 && (
          <button
            onClick={onReset}
            className="w-8 h-8 flex items-center justify-center bg-[#a08d70]/80 hover:bg-[#a08d70] text-white rounded-full transition-all duration-100 active:scale-95 active:shadow-inner"
            title="รีเซ็ตเป็นค่าเริ่มต้น"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
          </button>
        )}
        <button
          onMouseDown={(e) => handlePressStart(e, -step)}
          onMouseUp={handlePressEnd}
          onMouseLeave={handlePressEnd}
          onTouchStart={(e) => handlePressStart(e, -step)}
          onTouchEnd={handlePressEnd}
          disabled={value <= min}
          className="w-8 h-8 font-bold bg-[#b22222]/80 hover:bg-[#b22222] text-white rounded-full disabled:bg-gray-500/80 transition-all duration-100 flex items-center justify-center active:scale-95 active:shadow-inner select-none touch-manipulation"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={3}
              d="M20 12H4"
            />
          </svg>
        </button>
        <span className="text-xl font-bold w-10 text-center text-[#5a4a3a] select-none">
          {value}
        </span>
        <button
          onMouseDown={(e) => handlePressStart(e, step)}
          onMouseUp={handlePressEnd}
          onMouseLeave={handlePressEnd}
          onTouchStart={(e) => handlePressStart(e, step)}
          onTouchEnd={handlePressEnd}
          disabled={value >= max}
          className="w-8 h-8 font-bold bg-[#556b2f]/80 hover:bg-[#556b2f] text-white rounded-full disabled:bg-gray-500/80 transition-all duration-100 flex items-center justify-center active:scale-95 active:shadow-inner select-none touch-manipulation"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={3}
              d="M12 4v16m8-8H4"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
